import { render, staticRenderFns } from "./Examenes.vue?vue&type=template&id=1e4b08d8&"
import script from "./Examenes.vue?vue&type=script&lang=js&"
export * from "./Examenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QToolbar,QToolbarTitle,QBtn,QSeparator,QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QToolbar,QToolbarTitle,QBtn,QSeparator,QTable,QTd})
